import { RequestOptions, Request, Response, Headers, Http } from '@angular/http';
import { Injectable, Optional, Inject } from '@angular/core';
import { Cookie } from './cookie';
import { Observable, ReplaySubject, throwError, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { AuthService as AngularxAuthService } from 'angularx-social-login';
import { AmToasterService } from '@angularminds/am-toaster';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _organizations: ReplaySubject<Array<any>> = new ReplaySubject(1);
  private _currentUser: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _delegatedToMe: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _token: ReplaySubject<String> = new ReplaySubject(1);
  private _loggedIn: ReplaySubject<boolean> = new ReplaySubject(1);
  private _activeOrganization: ReplaySubject<any> = new ReplaySubject(1);
  private _activeRole: ReplaySubject<any> = new ReplaySubject(1);
  /**
   * Current organizations for logged in user
   */
  organizations: Observable<Array<any>> = this._organizations.asObservable();

  /**
   * Current organization or undefined if it's personal
   */
  activeOrganization: Observable<any> = this._activeOrganization.asObservable();

  /**
   * Current user
   *
   */
  currentUser: Observable<any> = this._currentUser.asObservable();

  /**
   * Token for current user
   */
  token: Observable<any> = this._token.asObservable();

  /**
   * Current logged in status
   */
  loggedIn: Observable<boolean> = this._loggedIn.asObservable();

  baseApi = environment.baseUrl || '';
  production = environment.production || false;

  /**
   * Base host of app
   */
  public baseHost(): string {
    return Cookie.get('_host');
  }

  constructor(
    private http: Http,
    public router: Router, //
    private angularxAuthService: AngularxAuthService,
    private amToasterService: AmToasterService,
  ) {
    this.init();
  }

  init() {
    const _token = Cookie.get('_token');
    if (_token) {
      this._token.next(_token);
      this._loggedIn.next(true);

      const user = JSON.parse(localStorage.getItem('_activeUser'));
      if (!user || !user._pre) {
        this.loadCurrentUser();
        this.loadOrganizations();
      }
    } else {
      this._loggedIn.next(false);
    }
  }

  login(email: string, password: string, reCaptchaToken: string): Subject<any> {
    console.log('reCaptchaToken: ', reCaptchaToken);
    console.log('password: ', password);
    console.log('email: ', email);
    const url = '/api/auth/login';
    const body = {
      email: email,
      password: password,
      reCaptchaToken: reCaptchaToken,
    };
    const subject = new Subject<any>();
    console.log('body: ', body);
    const request = this.makeRequest('POST', url, body);
    console.log('request: ', request);
    request.subscribe(
      (r: any) => {
        console.log('r: ', r);
        this.handleLogin(r);
        subject.next(r);
      },
      error => {
        console.log('error: ', error);
        subject.error(error);
      },
    );
    return subject;
  }

  loginWithGoogle(body): Subject<any> {
    const url = '/api/auth/google';
    const subject = new Subject<any>();
    const request = this.makeRequest('POST', url, body);
    request.subscribe(
      (response: any) => {
        if (response.user && response.user._id) {
          this.handleLogin(response);
        } else {
          try {
            const now = new Date();
            const host = window.location.hostname === 'localhost' ? '' : `.${this.getHost().host}`;
            Cookie.set(
              '_google_token',
              response.googlePayload.idToken,
              new Date(now.setFullYear(now.getFullYear() + 10)),
              '/',
              host,
            );
          } catch (e) {
            console.log(e);
          }
        }
        subject.next(response);
      },
      error => {
        subject.error(error);
      },
    );
    return subject;
  }

  secondFactor(code: string): Subject<any> {
    const url = '/api/auth/second-factor';
    const body = {
      code: code,
    };
    const subject = new Subject<any>();
    const request = this.makeRequest('POST', url, body);
    request.subscribe(
      (r: any) => {
        this.handleLogin(r);
        subject.next(r);
      },
      error => {
        subject.error(error);
      },
    );
    return subject;
  }

  regenerateSecondFactor(): Subject<any> {
    const url = '/api/auth/regenerate-second-factor';
    const subject = new Subject<any>();
    const request = this.makeRequest('GET', url);
    request.subscribe(
      (r: any) => {
        this.handleLogin(r);
        subject.next(r);
      },
      error => {
        subject.error(error);
      },
    );
    return subject;
  }

  chooseOrganization(organization: any): Subject<any> {
    const url = `/api/users/switch-organization/${organization._id}`;
    const subject = new Subject<any>();
    const request = this.makeRequest('GET', url);
    request.subscribe(
      (response: any) => {
        this.handleLogin(response);
        subject.next(response);
      },
      error => {
        subject.error(error);
      },
    );
    return subject;
  }

  setDefaultOrganization(organization: any): Subject<any> {
    const url = `/api/users/organization/default`;
    const subject = new Subject<any>();
    const request = this.makeRequest('PUT', url, { _activeOrg: organization._id });
    request.subscribe(
      (response: any) => {
        subject.next(response);
      },
      error => {
        subject.error(error);
      },
    );
    return subject;
  }

  logout(): Subject<any> {
    const url = `/api/auth/logout`;
    const subject = new Subject<any>();
    const request = this.makeRequest('GET', url);
    request.subscribe(
      (response: any) => {
        // clear token remove user from local storage to log user out
        this.removeAuthCookie();
        this.logoutFormGoogle();
        this._loggedIn.next(false);
        subject.next(response);
      },
      error => {
        subject.error(error);
      },
    );
    return subject;
  }

  localLogout(): Observable<any> {
    return new Observable<any>((observer: any) => {
      // clear token remove user from local storage to log user out
      this.removeAuthCookie();
      this.logoutFormGoogle();
      this._loggedIn.next(false);
      observer.next();
    });
  }

  logoutFormGoogle() {
    this.angularxAuthService.signOut().catch((error: Error) => {
      // this.notification.error('Error While Sign out from google', error.message);
    });
  }

  verifyInvitationLink(token: string, path?: string): Observable<any> {
    const url = path || `/api/invite-users/self`;
    const request = this.makeRequest('GET', url, null, null, { Authorization: `${token}` });
    return request;
  }

  verifyCommissionRequestLink(token: string, action: string): Observable<any> {
    const url = `/api/money-requests/self/verify?action=${action}`;
    const request = this.makeRequest('GET', url, null, null, { Authorization: `${token}` });
    return request;
  }

  verifyAgentInviteLink(token: string): Observable<any> {
    const url = `/api/agent-invites/self`;
    const request = this.makeRequest('GET', url, null, null, { Authorization: `${token}` });
    return request;
  }

  acceptInvite(invite: any, token: string): Observable<any> {
    const url = '/api/invite-users/accept';
    const request = this.makeRequest('POST', url, invite, null, { Authorization: `${token}` });
    // request.subscribe((r: any) => this.handleLogin(r));
    return request;
  }

  acceptAgentInvite(invite: any, token: string): Observable<any> {
    const url = '/api/agent-invites/accept';
    const request = this.makeRequest('POST', url, invite, null, { Authorization: `${token}` });
    // request.subscribe((r: any) => this.handleLogin(r));
    return request;
  }

  setPassword(setPassword: any, token: string): Observable<any> {
    const url = '/api/user/password';
    const request = this.makeRequest('PUT', url, setPassword, undefined, {
      Authorization: `${token}`,
    });
    // request.subscribe((r: any) => this.handleLogin(r));
    return request;
  }

  resetPassword(resetPassword: any, token: string): Observable<any> {
    const url = '/api/user/password/reset';
    const request = this.makeRequest('POST', url, resetPassword, undefined, {
      Authorization: `${token}`,
    });
    // request.subscribe((r: any) => this.handleLogin(r));
    return request;
  }

  setRedirectionUrl() {
    const host = window.location.hostname === 'localhost' ? '' : `.${this.getHost().host}`;
    const now = new Date();
    Cookie.set(
      '_redirectUrl',
      window.location.href,
      new Date(now.setFullYear(now.getFullYear() + 10)),
      '/',
      host,
    );
  }

  getRedirectionUrl() {
    return Cookie.get('_redirectUrl');
  }

  clearRedirectionUrl() {
    const host = window.location.hostname === 'localhost' ? '' : `.${this.getHost().host}`;
    Cookie.delete('_redirectUrl', '/', host);
  }

  loadCurrentUser(): Observable<any> {
    const request = this.makeRequest('GET', '/api/auth/self', undefined, true);
    request.subscribe((response: any) => {
      localStorage.setItem('_activeUser', JSON.stringify(response));
      if (this.router.url === '/auth/login') {
        this.router.navigate(['wallets']);
      }
      this._currentUser.next(response);
    });
    return request;
  }

  refreshAvatar(res: any) {
    const user = JSON.parse(localStorage.getItem('_activeUser'));
    user.updatedAt = res.updatedAt;
    user.avatar = res.avatar;
    localStorage.setItem('_activeUser', JSON.stringify(user));
    this._currentUser.next(user);
  }

  isUserTokenAvailable() {
    const user = JSON.parse(localStorage.getItem('_activeUser'));
    const token = Cookie.get('_token');
    return user && token ? true : false;
  }

  loadOrganizations(): Observable<any> {
    const request = this.makeRequest('GET', '/api/auth/self');
    request.subscribe((response: any) => {
      this._organizations.next(response._org);
      const organization = response._org.find((o: any) => o._id === response._activeOrg);

      // If user logging in for first time as a owner of organization
      const user = JSON.parse(localStorage.getItem('_activeUser'));
      if (
        user._count <= 1 &&
        organization.createdBy === user._id &&
        (!organization.industry || !organization.peopleCountRange)
      ) {
        const host = window.location.hostname === 'localhost' ? '' : `.${this.getHost().host}`;
        const now = new Date();
        Cookie.set('_init', 'true', new Date(now.setFullYear(now.getFullYear() + 10)), '/', host);
      }

      organization
        ? this._activeOrganization.next(organization)
        : this._activeOrganization.next(undefined);
    });
    return request;
  }

  getHost() {
    if (window.location.hostname !== 'localhost') {
      const rawHost = window.location.host.split('.');
      const hosts: any = [];
      const nonHosts: any = [];
      rawHost.forEach((innerHost: any, index: number) => {
        if (index >= rawHost.length - 2) {
          hosts.push(innerHost);
        } else if (index === rawHost.length - 3) {
          hosts.push(innerHost);
        } else {
          nonHosts.push(innerHost);
        }
      });
      return {
        host: hosts.join('.'),
        nonHost: nonHosts.join('.'),
      };
    } else {
      return {
        host: window.location.host,
        nonHost: '',
      };
    }
  }

  setOrganizationOpenSettings(organization: any) {
    if (!organization) {
      return;
    }
    try {
      const host = window.location.hostname === 'localhost' ? '' : `.${this.getHost().host}`;
      const organizationSettings = _.pick(organization, '_id', 'enableLoginWith');
      const now = new Date();
      Cookie.set(
        '_settings',
        JSON.stringify(organizationSettings),
        new Date(now.setFullYear(now.getFullYear() + 10)),
        '/',
        host,
      );
    } catch (e) {
      console.log('e', e);
    }
  }

  getRequestUrl(path: string): string {
    return `${window.location.protocol}//${window.location.host}` + (path ? path : ``);
  }

  getParentDomainRequestUrl(path: string): string {
    const host =
      window.location.hostname === 'localhost' ? window.location.host : `${this.getHost().host}`;
    return `${window.location.protocol}//${host}` + (path ? path : ``);
  }

  removeAuthCookie() {
    const host = window.location.hostname === 'localhost' ? '' : `.${this.getHost().host}`;
    localStorage.removeItem('_activeUser');
    Cookie.delete('_token', '/', host);
    Cookie.delete('_google_token', '/', host);
    Cookie.delete('_host', '/', host);
    // Cookie.deleteAll('/', host || 'localhost');
  }

  private makeRequest(
    method: string,
    url: string,
    body: any = '',
    serviceHeader: boolean = false,
    customHeaders: any = '',
  ): Observable<any> {
    url = this.getRequestUrl(url) || this.baseApi + url;
    console.log('url: ', url);
    const options = new RequestOptions({
      method: method,
      url: url,
      withCredentials: true,
      headers: new Headers(),
    });

    console.log('body: ', body);
    if (body) {
      options.body = JSON.stringify(body);
    }

    options.headers.set('Content-Type', 'application/json');
    if (customHeaders && customHeaders.Authorization) {
      options.headers.set('Authorization', `${customHeaders.Authorization}`);
    } else {
      const _token = Cookie.get('_token');
      options.headers.set('Authorization', `${_token}`);
    }

    const request = this.http.request(new Request(options)).pipe(
      map((res: Response) => {
        // because 204 does not contain body
        if (res.status >= 201 && res.status <= 226) {
          return;
        }
        {
          return res.json();
        }
      }),
      catchError((err: any) => this.handleError(err)),
    );

    return request;
  }

  verifyActivationLink(token: string, activate: boolean = false): Observable<any> {
    const url = `/api/user/self` + (activate ? `?activate=${activate}` : ``);
    const request = this.makeRequest('GET', url, undefined, undefined, {
      Authorization: `${token}`,
    });
    // request.subscribe((r: any) => this.handleLogin(r));
    return request;
  }

  handleLogin(response: any) {
    const host = window.location.hostname === 'localhost' ? '' : `.${this.getHost().host}`;
    // login successful if there's a jwt token in the response
    if (response) {
      const _activeUser = response.user;
      const _token = response.token;
      const now = new Date();
      try {
        Cookie.set('_token', _token, new Date(now.setFullYear(now.getFullYear() + 10)), '/', host);
        Cookie.delete('_google_token', '/', host);
      } catch (e) {
        console.log(e);
      }
      localStorage.setItem('_activeUser', JSON.stringify(_activeUser));
      this._currentUser.next(_activeUser);
      this._token.next(_token);
      this._loggedIn.next(true);
      // this.router.navigate(['tasks'])
    } else {
      this.amToasterService.show('error', 'Login failed', 'Error!');
    }
  }

  /**
   * Handle HTTP error
   */
  handleError(error: any) {
    // We'd also dig deeper into the error to get a better message
    let errMsg = error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    if (error._body) {
      try {
        const json = error.json();
        if (json.message) {
          errMsg = json.message;
        } else {
          errMsg = json;
        }
      } catch (error) { }
    }
    console.error(errMsg); // log to console instead
    this.amToasterService.show('error', errMsg || 'Internal error', 'Oops!');
    console.log('error', error);
    if (error.status === 401) {
      this.localLogout().subscribe(logout => {
        window.location.href = this.getRequestUrl('/auth/login');
      });
    } else if (error.status === 403) {
      window.location.href = this.getRequestUrl('/wallets');
    }
    return throwError(errMsg);
  }

  shareCredential(user: string): Subject<any> {
    const url = '/api/users/share-credential';
    const body = {
      user: user,
    };
    const subject = new Subject<any>();
    const request = this.makeRequest('POST', url, body);
    request.subscribe(
      (r: any) => {
        subject.next(r);
      },
      error => {
        subject.error(error);
      },
    );
    return subject;
  }
}
